import React, { useEffect, useState } from 'react';

/**
 * CartBadge Component
 * 
 * Production-grade cart badge with dynamic number, 20px min width,
 * circular shape, and pulse animation on value update.
 * 
 * Expected to be positioned absolute relative to an icon container.
 * 
 * @param {Object} props
 * @param {number} props.count - Number of items in cart
 * @param {boolean} [props.animate=true] - Whether to animate on change
 */
const CartBadge = ({ count, animate = true }) => {
  const [isPulsing, setIsPulsing] = default_pulseValue();

  // Handle animation trigger on count change
  useEffect(() => {
    if (animate && count > 0) {
      setIsPulsing(true);
      const timer = setTimeout(() => setIsPulsing(false), 300); // Mathches 300ms keyframe
      return () => clearTimeout(timer);
    }
  }, [count, animate]);

  // Don't render badge if empty
  if (count <= 0) return null;

  return (
    <span
      className={`
        absolute -top-2 -right-2 
        min-w-[20px] h-[20px] 
        flex items-center justify-center 
        bg-light-accent-red dark:bg-brand-accent-red 
        text-white font-bold text-[12px] 
        rounded-pill px-[6px] py-[2px]
        ${isPulsing ? 'animate-badgePulse' : ''}
      `}
      aria-label={`${count} items in cart`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};

// Extracted state for testability and clearer logic separation
function default_pulseValue() {
  return useState(false);
}

export default CartBadge;
